module.exports = __webpack_public_path__ + "img/banner.26c9a5ed.jpg";